export default defineNuxtRouteMiddleware((to) => {
  const { isSubscribed, handleVisitorAction } = usePensionSubscribe()

  const preventUserAccess = to.meta.ultimateOnly && !isSubscribed.value
  if (preventUserAccess) handleVisitorAction()
})
